import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { DataContext } from './context/DataContext';

import AppRoutes from "./AppRoutes"; // We'll create this
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import { setLoginDataGlobal } from "./pages/Login/UserLogin";

function App() 
{
    const {loginData  } = useContext(DataContext);
    useEffect(() => { if (loginData) setLoginDataGlobal(loginData); }, [loginData]);

  return (
    <Router>
      <AppRoutes />
      <ToastContainer />
    </Router>
  );
}

export default App;
